var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[_vm.$style.arrow, ( _obj = {}, _obj[_vm.$style.big] = _vm.isBig, _obj )],on:{"click":function($event){return _vm.$emit('go', _vm.direction)}}},[_c(("Chevron" + _vm.direction),{tag:"component",staticClass:"icon-white",attrs:{"width":_vm.isBig ? '20px' : '15px',"height":_vm.isBig ? '20px' : '15px'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }